/**
 * Created by max on 22.03.17.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DefaultComponent} from './components/default/default.component';
import {AdultLanguageComponent} from './components/adultLanguage/adultLanguage.component';
import {HighschoolComponent} from './components/highschool/highschool.component';


const routes: Routes = [
    {path: '', redirectTo: '/default', pathMatch: 'full'},
    {path: 'default', component: DefaultComponent},
    {path: 'al', component: AdultLanguageComponent},
    {path: 'hs', component: HighschoolComponent},

];
@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
